import React, {Component} from 'react';
import CurrentBalanceWidget from "../components/widgets/CurrentBalanceWidget";
import PayoutHistoryWidget from "../components/widgets/PayoutHistoryWidget";
import {createConnectedAccount, deleteConnectedAccount, getConnectedAccount, getNonProfitBalance} from "../api/funding";
import {connect} from "react-redux";
import Spinner from "../components/Spinner";
import LinkABankWidget from "../components/widgets/LinkABankWidget";
import {Button} from "../components/atoms/buttons/Button";

function mapDispatchToProps(dispatch) {
    return {
        setAuthUser: (user) => {
            dispatch({
                type: "SET_AUTH_USER",
                user,
            })
        },
        setMobile: (mobile) => {
            dispatch({
                type: "SET_MOBILE",
                mobile,
            })
        },
        setSelectedNonProfit: (nonProfit) => {
            dispatch({
                type: "SET_SELECTED_NON_PROFIT",
                nonProfit,
            })
        }
    }
}

function mapStateToProps(state) {
    return {
        selectedNonProfit: state.userReducer.selectedNonProfit,
    }
}

class Funds extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            nonProfits: [],
            nonProfitData:
                {
                    overview: {},
                    header: {},
                    line_chart: {},
                    bar_chart: {},
                    history: [],
                    age_ranges: [],
                    challenge_v_direct: [{'x': ''}, {'x': ''}],
                    followers_v_donors: [{'x': ''}, {'x': ''}],
                },
            selectedNonProfit: '',
            linkLoading: false,
            connectedAccount: {},
            bankAccount: {},
            connected: false,
            accountNumber: '',
            balance: {}
        }
    }


    componentDidMount = () => {
        this.getBankInfo();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.selectedNonProfit !== prevProps.selectedNonProfit) {
            this.getBankInfo();
        }
    }

    getBankInfo = async () => {
        this.setState({loading: true})
        const connectedAccount = await getConnectedAccount(this.props.user, this.props.selectedNonProfit);
        const bankAccount = connectedAccount?.external_accounts?.data[0];
        const balance = await getNonProfitBalance(this.props.user, this.props.selectedNonProfit);
        this.setState({
            loading: false,
            connectedAccount: connectedAccount,
            bankAccount: bankAccount,
            connected: !!bankAccount,
            balance: balance
        })
    }

    tryLinkAccount = async () => {
        this.setState({linkLoading: true})
        const newAccount = await createConnectedAccount(this.props.user, this.props.selectedNonProfit, this.state.accountNumber);
        this.setState({connectedAccount: newAccount, connected: true, linkLoading: false})
    }

    changeAccountNumber = (e) => {
        this.setState({accountNumber: e.target.value})
    }

    deleteAccount = async () => {
        this.setState({loading: true})
        const connectedAccount = await deleteConnectedAccount(this.props.user, this.props.selectedNonProfit);
        this.setState({
            loading: false,
            connectedAccount: {},
            bankAccount: {},
            connected: false
        })
    }


    render() {
        if (this.state.loading) {
            return (
                <div className="h-[100vh] flex flex-col items-center justify-center">
                    <Spinner size={40}/>
                    <p className='text-sm mt-5 text-slate-500'>
                        Loading funds
                    </p>
                </div>
            )
        }
        return (
            <div className='w-full h-[100vh] flex flex-col items-center justify-center bg-brand'>
                <div className='burst'/>
                <div className='burst2'/>
                <div className='mb-5'>
                    <img className='w-40' src={require('../img/brand/full_logo.png')}/>
                </div>
                <div className='flex flex-col bg-white z-[2] shadow-2xl p-8 rounded-2xl mb-5 w-[500px]'>
                    <p className={'heading3 text-gray-800 mb-4'}>
                        Collect Your Donations Through Starfish
                    </p>
                    <p className='body1 text-gray-500 mb-6'>
                        To start collecting donations for your nonprofit, please create an account with Change, our trusted third-party provider for payment processing.
                    </p>
                    <p className='body1 text-gray-500 mb-6'>
                        Once you've created your account, you can claim your nonprofit through their platform to begin accepting donations through Starfish.
                    </p>
                    <div className='w-full flex-1 flex-col flex items-stretch justify-stretch'>
                        <a 
                            href="https://api.getchange.io/sign_up?nonprofit" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className='w-full flex-1 flex flex-col'
                        >
                            <Button variant={'default'} className='mt-4 w-full'>
                                Set Up Donations
                            </Button>
                        </a>
                    </div>
                </div>
                
                {/* Commented out existing widgets */}
                {/*<FundsOverviewWidget data={this.state.nonProfitData.overview}/>*/}
                {/*<CurrentBalanceWidget bankAccount={this.state.bankAccount} connected={this.state.connected}
                                      tryLinkAccount={this.tryLinkAccount} deleteAccount={this.deleteAccount}
                                      changeAccountNumber={this.changeAccountNumber}
                                      balance={this.state.balance} loading={this.state.loading}
                />
                <div className='relative'>
                    {!this.state.connected &&
                        <div className='absolute left-0 right-0 top-0 z-[0] blur-sm'>
                            <PayoutHistoryWidget dummyData/>
                        </div>
                    }
                </div>
                {this.state.connected &&
                    <PayoutHistoryWidget/>
                }
                <LinkABankWidget linkLoading={this.state.linkLoading} accountNumber={this.state.accountNumber}
                                 bankAccount={this.state.bankAccount} connected={this.state.connected}
                                 tryLinkAccount={this.tryLinkAccount} deleteAccount={this.deleteAccount}
                                 changeAccountNumber={this.changeAccountNumber}/>*/}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Funds);
